import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BestTicketBlockDetails, TicketDetails } from "features/types";

interface ChangeSeatsState {
  tickets: TicketDetails[];
  dialogVisible: boolean;
  step: number;
  selectedBestBlock: BestTicketBlockDetails | null;
}

const initialState: ChangeSeatsState = {
  tickets: [],
  dialogVisible: false,
  step: 1,
  selectedBestBlock: null,
};

const changeSeatsSlice = createSlice({
  name: "changeSeats",
  initialState,
  reducers: {
    setTickets: (state, action: PayloadAction<TicketDetails[]>) => {
      state.tickets = action.payload;
    },
    setDialogVisible: (state, action: PayloadAction<boolean>) => {
      state.dialogVisible = action.payload;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setSelectedBestBlock: (
      state,
      action: PayloadAction<BestTicketBlockDetails>
    ) => {
      state.selectedBestBlock = action.payload;
    },
  },
});

export const { setTickets, setDialogVisible, setStep, setSelectedBestBlock } =
  changeSeatsSlice.actions;
export default changeSeatsSlice.reducer;
